export default __webpack_public_path__ + "accelerateur.c132502.png";